exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-table {\n  overflow: auto;\n  max-height: 500px; }\n\n.mat-cell {\n  padding: 0.5rem 0.5rem 0.5rem 0; }\n\n.mat-column-id {\n  -ms-flex: 0 0 3%;\n      flex: 0 0 3%; }\n\n.mat-column-name {\n  -ms-flex: 0 0 10%;\n      flex: 0 0 10%; }\n\n.mat-column-description {\n  -ms-flex: 0 0 25%;\n      flex: 0 0 25%; }\n\n.mat-column-namespace {\n  -ms-flex: 0 0 25%;\n      flex: 0 0 25%; }\n\n.mat-column-author {\n  -ms-flex: 0 0 10%;\n      flex: 0 0 10%; }\n\n.mat-column-lastUpdate {\n  -ms-flex: 0 0 10%;\n      flex: 0 0 10%; }\n\n.mat-column-status {\n  -ms-flex: 0 0 5%;\n      flex: 0 0 5%; }\n\nspan {\n  font-size: 12px;\n  font: Poppins;\n  color: #607d8b; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/importar-modelo/importar-modelo.component.scss
// module id = ../../../../../src/app/importar-modelo/importar-modelo.component.scss
// module chunks = main